import { render, staticRenderFns } from "./comments-table.vue?vue&type=template&id=5b518a29&scoped=true"
import script from "./comments-table.vue?vue&type=script&lang=js"
export * from "./comments-table.vue?vue&type=script&lang=js"
import style0 from "./comments-table.vue?vue&type=style&index=0&id=5b518a29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b518a29",
  null
  
)

export default component.exports